// import { textFilter, selectFilter, dateFilter } from 'react-bootstrap-table2-filter';
import ContractFeesColumns from './ContractFees';
import ContractTeamsColumns from './TeamInitialisation';
import ContractTemplatesColumns from './ContractTemplates';
import ScriptAllocationColumns from './ScriptAllocation';
import ScriptDatesColumns from './ScriptDates';
import MarkerMeetingsColumns from './MarkerMeetingsColumns';
import CentralMarkerMeetingsColumns from './CentralMarkerMeetingsColumns';

const Columns = {
	ContractTeamsColumns,
	ContractTemplatesColumns,
	ContractFeesColumns,
	ScriptAllocationColumns,
	ScriptDatesColumns,
	MarkerMeetingsColumns,
	CentralMarkerMeetingsColumns
};

export default Columns;
